import { toValue, type MaybeRefOrGetter, ref, watchEffect, type Ref } from "vue"
import type { EntityInfo } from "../entityInfo"
import { CreateEntityData } from "./entities"
import type { Fleet } from "./fleet"
import { shipNoNulls } from "./loaders/fleet"
import type { Settings } from "./settings"
import type { Coordinates } from "./types"

class Flight {
    fleet: Fleet
    settings: Settings
    entities: EntityInfo

    constructor(fleet: MaybeRefOrGetter<Fleet>, entities: MaybeRefOrGetter<EntityInfo>, settings: Settings) {
        this.fleet = toValue(fleet)
        this.entities = toValue(entities)
        this.settings = settings
    }

    Consumption = () => {

    }

    Duration = () => {

    }
}

const Capacity = (fleet: MaybeRefOrGetter<Fleet>, entities: MaybeRefOrGetter<EntityInfo>, settings: MaybeRefOrGetter<Settings>): number => {
    let result = 0;
    const f = toValue(fleet)

    for (const entityId in f.ships) {
        const amount = f.ships[entityId].amount || 0
        if (amount == 0) { continue }

        const cap = CreateEntityData(entityId, shipNoNulls(f.ships[entityId]), toValue(entities)[entityId], f, toValue(settings)).cargo || 0
        result += cap * amount
    }

    return result
}

const Distance = (c1: Coordinates, c2: Coordinates, settings: Settings): (number | null) => {
    if (c1.galaxy == null || c2.galaxy == null) {
        return null
    }
    if (c1.galaxy != c2.galaxy) {
        let d = Math.abs(c1.galaxy - c2.galaxy)
        d = settings.donutGalaxy ? Math.min(d, settings.numberOfGalaxies - d) : d;
        return 20000 * d
    }

    if (c1.system == null || c2.system == null) {
        return null
    }
    if (c1.system != c2.system) {
        let d = Math.abs(c1.system - c2.system)
        d = settings.donutSystem ? Math.min(d, 499 - d) : d;
        return 2700 + 95 * d
    }
    
    if (c1.position == null || c2.position == null) {
        return null
    }
    if (c1.position != c2.position) {
        return 1000 + 5 * Math.abs(c1.position - c2.position)
    }

    return 5
}

const Duration = (fleet: Fleet, distance: number | null, friendly: boolean, entities: EntityInfo, settings: MaybeRefOrGetter<Settings>) => {
    if (distance == null) {
        return null
    }

    // this is a bit of a whacky hack, but it's the only way to get the reactive state to work
    // with my current knowledge
    const speed = friendly ? toValue(settings).fleetHoldSpeed : toValue(settings).fleetWarSpeed;

    const maxSpeed = getMaxSpeed(fleet, entities, toValue(settings))
    console.log('calced max speed', maxSpeed)
    if (maxSpeed == null) {
        return null
    }

    return Math.max(
        Math.round((35000 / (fleet.speed/10) * Math.sqrt(distance * 10 / maxSpeed) + 10) / speed),
        1
    )
}

const getMaxSpeed = (fleet: Fleet, entities: EntityInfo, settings: Settings): (number | null) => {
    let result = null

    for (const entityId in fleet.ships) {
        if (fleet.ships[entityId].amount == null || fleet.ships[entityId].amount == 0) {
            continue
        }

        const data = CreateEntityData(entityId, shipNoNulls(fleet.ships[entityId]), entities[entityId], fleet, settings)
        console.log('data', entityId, data)
        result = Math.min(result || 1e100, Math.floor(data.speed || 0))
    }

    return result
} 

function useCapacity(fleet: MaybeRefOrGetter<Fleet>, entities: MaybeRefOrGetter<EntityInfo>, settings: MaybeRefOrGetter<Settings>) {
    const fuel = ref(0)

    watchEffect(() => {
        fuel.value = Math.floor(Capacity(fleet, entities, settings))
    })

    return fuel
}

function useDistance(attacker: MaybeRefOrGetter<Fleet>, defender: MaybeRefOrGetter<Fleet>, settings: MaybeRefOrGetter<Settings>) {
    const distance: Ref<number | null> = ref(0)

    watchEffect(() => {
        distance.value = Distance(toValue(attacker).coordinates, toValue(defender).coordinates, toValue(settings))
    })

    return distance
}

function useDuration(fleet: MaybeRefOrGetter<Fleet>, distance: MaybeRefOrGetter<number | null>, friendly: boolean, entities: MaybeRefOrGetter<EntityInfo>, settings: MaybeRefOrGetter<Settings>) {
    const duration: Ref<number | null> = ref(0)

    watchEffect(() => {
        if (toValue(fleet).isDefender) {
            duration.value = null
        } else {
            duration.value = Duration(
                toValue(fleet),
                toValue(distance),
                friendly,
                toValue(entities),
                settings
            )
        }

    })

    return duration
}

// import { Duration, FuelConsumption } from '@/lib/flight';
// computed: {
//     fuelConsumption(): (number | null) {
//         if (this.activeFleet.ID == this.defender.ID) {
//             return null
//         }

//         let speed = this.title == 'attackers' ? this.settings.fleetWarSpeed : this.settings.fleetHoldSpeed;

//         let consumption = FuelConsumption(this.activeFleet, this.defender.coordinates, this.settings, this.activeFleet.speed, speed)

//         if (consumption != null) {
//             this.activeFleet.fuelConsumption = consumption;
//         }
//         return consumption
//     },
//     duration(): (string | null) {
//         if (this.activeFleet.ID == this.defender.ID) {
//             return null
//         }
//         return this.formatDuration(Duration(this.activeFleet, this.defender.coordinates, this.settings.fleetWarSpeed, this.activeFleet.speed, this.settings))
//     }
// },

export {
    Flight,
    useCapacity,
    useDistance,
    useDuration,
}